"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENSING_ID_ATTRIBUTE_NAME = exports.MAX_TEXT_CONTENT_LENGTH = exports.EVENT_ATTR_PREFIX = exports.CFP_LOGGED_OUT_STATE = exports.CFP_LOGGED_IN_STATE = exports.CFP_AUTH_EVENT = exports.CFP_EVENT_CLIENT_ID = exports.AUTH_SOURCE = exports.AUTH_SOURCE_INTERNAL = exports.MAX_MESSAGE_STORAGE = exports.ADP_SENDER = exports.ADP_ACTION = exports.DHIG_COLOR_VARIANTS = exports.WEAVE_DENSITY_VARIANTS = exports.WEAVE_COLOR_VARIANTS = exports.UI_THEME = exports.UTM_PARAMETERS = exports.PRIVACY_MAPPING = exports.DEFAULT_COOKIE_DOMAIN = exports.ADP_WEB_PRIVACY_GPC_COOKIE_NAME = exports.ADP_WEB_PRIVACY_COOKIE_NAME = exports.SESSION_COOKIE_NAME = exports.PRIVACY_PREFERENCES_COOKIE_NAME = exports.ANONYMOUS_ID_COOKIE_NAME = exports.HTML_ATTR_PAGE_PROPERTY_PREFIX = exports.HTML_ATTR_COMPONENT_METRIC_PREFIX_LEGACY = exports.HTML_ATTR_COMPONENT_ATTR_PREFIX_LEGACY = exports.HTML_ATTR_COMPONENT_TYPE_LEGACY = exports.HTML_ATTR_COMPONENT_NAME_LEGACY = exports.HTML_ATTR_COMPONENT_ID_LEGACY = exports.HTML_ATTR_COMPONENT_METRIC_PREFIX = exports.HTML_ATTR_COMPONENT_ATTR_PREFIX = exports.HTML_ATTR_COMPONENT_TYPE = exports.HTML_ATTR_COMPONENT_NAME = exports.HTML_ATTR_COMPONENT_ID = exports.HTML_ATTR_CAPTURE_CLICK_LEGACY = exports.HTML_ATTR_CAPTURE_CLICK = exports.HTML_ATTR_CAPTURE_PAGE = exports.UserConsentStatusCode = exports.USER_IDENTITY_PROVIDER = exports.DEFAULT_SESSION_TTL = exports.ERROR_MESSAGE = exports.RETRY_COUNT = exports.BASE_DELAY = exports.SERVERS = exports.SDK_VERSION = exports.PKG_VERSION = exports.SCHEMA_VERSION = exports.DEFAULT_ENV = exports.consentDialogHTML = void 0;
exports.DEFAULT_ASSISTANT_TIMEOUT = exports.SDK_AUTO_CAPTURE_KEY = exports.REFERRER_PARAMS = exports.WEB_CONTAINER_REFERRER_TYPE = exports.EVENT_FIELD_STRING_LIMIT = exports.WEB_CONTAINER_VERSION = exports.FLOOR_SCROLL_DEBOUNCE_DURATION = exports.DEFAULT_SCROLL_DEBOUNCE_DURATION = void 0;
require("./scss/styles.scss");
// @ts-ignore
var consentDialog_html_1 = require("./html/consentDialog.html");
Object.defineProperty(exports, "consentDialogHTML", { enumerable: true, get: function () { return __importDefault(consentDialog_html_1).default; } });
/**
 * Webpack replaces these global vars with string literals.
 * We export them just to make it easier to unit test this file.
 */
exports.DEFAULT_ENV = global.WEBPACK_DEFAULT_ENV;
exports.SCHEMA_VERSION = global.WEBPACK_SCHEMA_VERSION;
exports.PKG_VERSION = global.WEBPACK_PKG_VERSION;
exports.SDK_VERSION = global.WEBPACK_SDK_VERSION;
exports.SERVERS = {
    dev: {
        analytics: "https://ase-dev.autodesk.com/adp/v1/analytics/upload",
        whitelist: "https://adppa-dev.api.autodesk.com/api/v1/whitelist",
        userConsent: "https://adppa-dev.api.autodesk.com/config/v1/pups",
        webContainer: "https://ase-cdn-stg.autodesk.com/adp/ad-csi-panel-web/r{{version}}/index.html?env=dev",
        ipm: `https://ase-cdn-stg.autodesk.com/adp/v${exports.PKG_VERSION}/js/@adsk/adp-web-analytics-sdk-ipm.min.js`,
    },
    stg: {
        analytics: "https://ase-stg.autodesk.com/adp/v1/analytics/upload",
        whitelist: "https://adppa-stg.api.autodesk.com/api/v1/whitelist",
        userConsent: "https://adppa-stg.api.autodesk.com/config/v1/pups",
        webContainer: "https://ase-cdn-stg.autodesk.com/adp/ad-csi-panel-web/r{{version}}/index.html",
        ipm: `https://ase-cdn-stg.autodesk.com/adp/v${exports.PKG_VERSION}/js/@adsk/adp-web-analytics-sdk-ipm.min.js`,
    },
    prd: {
        analytics: "https://ase.autodesk.com/adp/v1/analytics/upload",
        whitelist: "https://adppa.api.autodesk.com/api/v1/whitelist",
        userConsent: "https://adppa.api.autodesk.com/config/v1/pups",
        webContainer: "https://ase-cdn.autodesk.com/adp/ad-csi-panel-web/r{{version}}/index.html",
        ipm: `https://ase-cdn.autodesk.com/adp/v${exports.PKG_VERSION}/js/@adsk/adp-web-analytics-sdk-ipm.min.js`,
    },
};
exports.BASE_DELAY = 1000;
exports.RETRY_COUNT = 3;
exports.ERROR_MESSAGE = {
    unknownApiError: "Unknown API error",
    invalidArguments: "Invalid arguments",
    invalidUserToken: "Invalid user token",
    adpNotLoaded: "adp.load() must be called first",
    userConsentNotLoaded: "User info and/or user consent has not been loaded yet",
    userConsentUnexpectedError: "An unexpected error has occurred",
    userConsentPendingUserAction: "User action is required",
    userConsentOptOut: "The user has opt-out of tracking",
    userConsentOptIn: "No further user consent action is required",
    userConsentApiError: "The user consent could not be retrieved",
};
exports.DEFAULT_SESSION_TTL = 60 * 60 * 1000; // 1 hour
exports.USER_IDENTITY_PROVIDER = {
    SDK: "web_sdk",
    COOKIE: "cookie",
    O2: "O2",
    LDAP: "LDAP",
};
var UserConsentStatusCode;
(function (UserConsentStatusCode) {
    UserConsentStatusCode[UserConsentStatusCode["userOptIn"] = 0] = "userOptIn";
    UserConsentStatusCode[UserConsentStatusCode["userOptOut"] = 1] = "userOptOut";
    UserConsentStatusCode[UserConsentStatusCode["userPendingAction"] = 2] = "userPendingAction";
})(UserConsentStatusCode = exports.UserConsentStatusCode || (exports.UserConsentStatusCode = {}));
const ADP = "adp";
exports.HTML_ATTR_CAPTURE_PAGE = `data-${ADP}-page`;
exports.HTML_ATTR_CAPTURE_CLICK = `data-${ADP}-click`;
exports.HTML_ATTR_CAPTURE_CLICK_LEGACY = `${ADP}-click`;
exports.HTML_ATTR_COMPONENT_ID = `data-${ADP}-component-id`;
exports.HTML_ATTR_COMPONENT_NAME = `data-${ADP}-component-name`;
exports.HTML_ATTR_COMPONENT_TYPE = `data-${ADP}-component-type`;
exports.HTML_ATTR_COMPONENT_ATTR_PREFIX = `data-${ADP}-component-attribute-`;
exports.HTML_ATTR_COMPONENT_METRIC_PREFIX = `data-${ADP}-component-metric-`;
exports.HTML_ATTR_COMPONENT_ID_LEGACY = `${ADP}-component-id`;
exports.HTML_ATTR_COMPONENT_NAME_LEGACY = `${ADP}-component-name`;
exports.HTML_ATTR_COMPONENT_TYPE_LEGACY = `${ADP}-component-type`;
exports.HTML_ATTR_COMPONENT_ATTR_PREFIX_LEGACY = `${ADP}-component-attribute-`;
exports.HTML_ATTR_COMPONENT_METRIC_PREFIX_LEGACY = `${ADP}-component-metric-`;
exports.HTML_ATTR_PAGE_PROPERTY_PREFIX = "adpPageProperty";
exports.ANONYMOUS_ID_COOKIE_NAME = "ADSK_ADP_UID";
exports.PRIVACY_PREFERENCES_COOKIE_NAME = "OPTOUTMULTI";
exports.SESSION_COOKIE_NAME = "ADCSI_REF";
exports.ADP_WEB_PRIVACY_COOKIE_NAME = "ADP_WPS";
exports.ADP_WEB_PRIVACY_GPC_COOKIE_NAME = "ADP_WPS_GPC";
exports.DEFAULT_COOKIE_DOMAIN = "autodesk.com";
exports.PRIVACY_MAPPING = {
    STRICTLY_NECESSARY: {
        PRODUCT: "ADSK_PUD_CONTRACTUAL_NECESSITY_DESKTOP",
        WEB: "ADSK_WEB_PREFERENCES_STRICTLY_NEEDED",
    },
    PRODUCT_PRIVACY_ID: {
        ADSK_PUD_CONTRACTUAL_NECESSITY_DESKTOP: "c7",
        ADSK_PUD_OPTIMIZATION_IMPROVEMENT_DESKTOP: "c8",
        ADSK_PUD_GO_TO_MARKET_DESKTOP: "c9",
    },
    WEB_PRIVACY_ID: {
        ADSK_WEB_PREFERENCES_STRICTLY_NEEDED: "c7",
        ADSK_WEB_PREFERENCES_IMPROVEMENT: "c8",
        ADSK_WEB_PREFERENCES_ADVERTISEMENT: "c9",
    },
    OPTIN: { 0: true, 1: false },
};
exports.UTM_PARAMETERS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
exports.UI_THEME = {
    weave: "adp-weave",
    dhig: "adp-dhig",
};
exports.WEAVE_COLOR_VARIANTS = {
    lightGray: "adp-weave--light-gray",
    darkGray: "adp-weave--dark-gray",
    darkBlue: "adp-weave--dark-blue",
};
exports.WEAVE_DENSITY_VARIANTS = {
    highDensity: "adp-weave--high-density",
    mediumDensity: "adp-weave--medium-density",
    lowDensity: "adp-weave--low-density",
};
exports.DHIG_COLOR_VARIANTS = {
    dark: "adp-dhig--dark",
    light: "adp-dhig--light",
};
exports.ADP_ACTION = {
    IPM_CLOSE: "ipm.close",
};
exports.ADP_SENDER = "adp";
exports.MAX_MESSAGE_STORAGE = 1.6e7;
exports.AUTH_SOURCE_INTERNAL = "@internal";
exports.AUTH_SOURCE = {
    GENERIC: "generic",
    CFP: "cfp",
    LOAD_USER_CONSENT_PREFERENCES: `${exports.AUTH_SOURCE_INTERNAL}/loadUserConsentPreferences`,
    SET_USER_CONSENT_PREFERENCES: `${exports.AUTH_SOURCE_INTERNAL}/setUserConsentPreferences`,
    SET_USER_TOKEN_PROVIDER: `${exports.AUTH_SOURCE_INTERNAL}/setUserTokenProvider`,
};
exports.CFP_EVENT_CLIENT_ID = "adp-web-sdk";
exports.CFP_AUTH_EVENT = "cfp.auth.session-state-change";
exports.CFP_LOGGED_IN_STATE = "logged_in";
exports.CFP_LOGGED_OUT_STATE = "logged_in";
exports.EVENT_ATTR_PREFIX = "on";
exports.MAX_TEXT_CONTENT_LENGTH = 256;
exports.SENSING_ID_ATTRIBUTE_NAME = "data-adp-sense-id";
exports.DEFAULT_SCROLL_DEBOUNCE_DURATION = 750;
exports.FLOOR_SCROLL_DEBOUNCE_DURATION = 500;
exports.WEB_CONTAINER_VERSION = 1;
exports.EVENT_FIELD_STRING_LIMIT = 256;
exports.WEB_CONTAINER_REFERRER_TYPE = "web_application";
exports.REFERRER_PARAMS = {
    ID: "adp_referrer_id",
    NAME: "adp_referrer_name",
    VERSION: "adp_referrer_version",
    TYPE: "adp_referrer_type",
    SESSION: "adp_referrer_session",
};
exports.SDK_AUTO_CAPTURE_KEY = "ADP_SDK_AUTO";
exports.DEFAULT_ASSISTANT_TIMEOUT = 15000; // 15 seconds
